import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectGameData } from "../../Store/store";
import { queryString, storyFor } from "./storyCorner";

/**
 * Addresses from the retired Story path (2026-10-28), so old bookmarks and
 * shared links still land somewhere sensible:
 *
 *   /choose-path?difficulty=N          -> /choose-unit?difficulty=N (Discover)
 *   /choose-story-unit                 -> /story-book-corner (the shelves)
 *   /story-choose-game-type?...        -> that story's page in the Corner
 */
export const ChoosePathRedirect = () => {
  const { search } = useLocation();
  return <Navigate replace to={{ pathname: "/choose-unit", search }} />;
};

export const StoryUnitsRedirect = () => <Navigate replace to="/story-book-corner" />;

export const StoryGamesRedirect = () => {
  const { search } = useLocation();
  const gameData = useSelector(selectGameData) ?? [];
  const params = new URLSearchParams(search);
  const story = storyFor({ target: params.get("game-name"), unit: params.get("unit"), gameData });
  return (
    <Navigate
      replace
      to={{
        pathname: "/story-book-corner",
        search: story ? `?${queryString({ story })}` : "",
      }}
    />
  );
};
